// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__XhTq8","body":"modal_body__SQUnU","bodyDialog":"modal_bodyDialog__KmVcp","open":"modal_open__85i8l"};